export enum ClusterStatus {    
    Stalled = 1,
    Offers = 2,
    CrossMatching = 3,
    Logistics = 7,
    Kickoff = 4,
    InProcess = 8,
    NoMatch = 5,
    Transplanted = 6,
    KflId = 10
}